import { Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lfwms-itooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.css']
})
export class TooltipComponent implements OnInit {

  @Input() public tooltipMessage: string;
  @Input() public tooltipPosition: any;
  public msgToDisplay: string = '';
  public positionOfMsg: string;

  constructor() {
  }

  public ngOnInit() {
    this.msgToDisplay = this.tooltipMessage;
    this.positionOfMsg = this.tooltipPosition;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/tooltip/tooltip.component.ts